import React from "react";
import "../Css/Contact.css";
import flyer from "../Assets/QRCodeOnly.jpg";

const Contact = () => {
  return (
    <div className="contact-container">
      <div className="contact-layout">
        <div className="contact-left">
          <h2 className="contact-page-heading">
            Support our <span>mission.</span>
          </h2>
          <div className="contact-subheading">
            Your donation directly strengthens public-health equity in the communities we serve.
          </div>
        </div>
        <div className="contact-right">
          <img
            src={flyer}
            alt="SportsForEquity Flyer with QR Code"
            className="contact-flyer"
          />
        </div>
      </div>
    </div>
  );
};

export default Contact;
